import { useState, useEffect, useContext } from "react";
import HeaderDashboard from "../../Components/HeaderDashboard";
import { useLocation } from "react-router-dom";
import { GetBusTransactionDetails } from "../../Services/BusAPI";
import { PreCancellation, BookingCancellation } from "../../Services/BusAPI";
import { AuthContext } from "../../Routes/AuthProvider"


const BusCancellationBooking = () => {
    const location = useLocation();
    const { name, userName, roles, corporateId } = useContext(AuthContext);
    const queryParams = new URLSearchParams(location.search);
    function getParamIgnoreCase(key) {
        for (const [k, v] of queryParams.entries()) {
            if (k.toLowerCase() === key.toLowerCase()) {
                return v;
            }
        }
        return null;
    }
    const referenceNo = getParamIgnoreCase("ReferenceNo");
    const key = getParamIgnoreCase("key");
    const clientCode = getParamIgnoreCase("clientCode");

    const [bustransactionDetails, setBusTransactionDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [cancellationCharges, setCancellationCharges] = useState(null);
    const [hidePreCancellation, setHidePreCancellation] = useState(false);


    //  Debug logs
    useEffect(() => {
        //console.log("URL:", location.search);
        //console.log("ReferenceNo:", referenceNo);
        //console.log("ClientCode:", clientCode);
        //console.log("Key:", key);

        if (referenceNo && clientCode && key) {
            fetchBusTransactionDetails();
        } else {
            console.warn("Missing required params in URL");
        }
    }, [referenceNo, clientCode, key]);

    //  API Call
    const fetchBusTransactionDetails = async () => {
        try {
            setLoading(true);
            setError("");

            const params = {
                ClientCode: clientCode,
                Key: key,
                referenceNo: referenceNo,
            };

            //console.log("FINAL API BODY:", params);
            const response = await GetBusTransactionDetails(params);
            //console.log("FULL RESPONSE OBJECT:", JSON.stringify(response, null, 2));

            //console.log("GetBusTransactionDetails:", response);

            setBusTransactionDetails(response);

        } catch (err) {
            console.error("API ERROR:", err);
            setError("Failed to load Transaction details.");
        } finally {
            setLoading(false);
        }
    };

    //  Safe Data
    const booking = bustransactionDetails?.booking;
    const bookingPoints = bustransactionDetails?.bookingPoints;
    const passengers = bustransactionDetails?.passengers || [];
    const payments = bustransactionDetails?.payments?.[0] || [];

    const formatTime = (dateTime) => {
        if (!dateTime) return "";
        return new Date(dateTime).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    const formatDate = (dateTime) => {
        if (!dateTime) return "";
        return new Date(dateTime).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };



    const handlePrintTicket = () => {
        const url = `/reservations/bus/BusPrintTicket?ReferenceNo=${booking?.referenceNo}&clientCode=${clientCode}&key=${key}`;
        const printWindow = window.open(url, "_blank");

        if (printWindow) {
            printWindow.focus();
        }
    };

    const handleInvoiceTicket = () => {
        const url = `/reservations/bus/PrintInvoice?ReferenceNo=${booking?.referenceNo}&clientCode=${clientCode}&key=${key}`;
        const printWindow = window.open(url, "_blank");

        if (printWindow) {
            printWindow.focus();
        }
    };

    const [selectedSeats, setSelectedSeats] = useState([]);

    const handlePassengerSelect = (seatNo) => {
        setSelectedSeats(prev => {
            if (prev.includes(seatNo)) {
                return prev.filter(id => id !== seatNo);
            } else {
                return [...prev, seatNo];
            }
        });
    };

    const PreCancelledMyBooking = async () => {
        if (!selectedSeats.length) {
            alert("Please select at least one passenger");
            return;
        }
        alert(selectedSeats);
        // if (!cancelReason) {
        //   alert("Please select cancellation reason");
        //   return;
        // }
        try {
            setLoading(true);
            localStorage.setItem("selectedSeats", selectedSeats);
            const requestBody = {
                TktNo: booking?.pnr,
                ClientCode: clientCode,
                Key: key,
                Seats: [selectedSeats.toString()],
            };

            const response = await PreCancellation(requestBody);
            //console.log("Cancellation success:", response);
            if (response.status === "success") {
                setHidePreCancellation(true);
                alert("Ticket pre cancelled successfully");
                setCancellationCharges(response);
                //      navigate(
                //     `/Reservations/Flight/TransactionDetails?referenceNo=${referenceNo}`
                //   );

            } else {
                alert("Oops, action not completed. Try Again!!");
            }

        } catch (error) {
            console.error(error);
            alert("Cancellation failed");
        } finally {
            setLoading(false);
        }
    };

    const CancelledMyBooking = async () => {
        try {
            setLoading(true);
            const savedSeats = localStorage.getItem("selectedSeats");
            const requestBody = {
                TktNo: booking?.pnr,
                ClientCode: clientCode,
                UserName: userName,
                CancellationCharge: 0,
                Key: key,
                Seats: [savedSeats],
            };

            const response = await BookingCancellation(requestBody);
            //console.log("Cancellation success:", response);
            if (response.status === "success") {
                //setHidePreCancellation(true);
                alert("Ticket cancelled successfully");
                setCancellationCharges(response);
                //      navigate(
                //     `/Reservations/Bus/TransactionDetails?referenceNo=${referenceNo}`
                //   );

            } else {
                alert("Oops, action not completed. Try Again!!");
            }

        } catch (error) {
            console.error(error);
            alert("Cancellation failed");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}

            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Bus</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>
                                <li class="breadcrumb-item text-gray-900">Cancellation Booking</li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0 me-2 d-none-mob">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                                        <img src="/assets/images/back.png" width={30} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section className="wraper">
                <div className="box_shadow mt-14">
                    <div className="row mamage_depo">
                        <div className="col-lg-6">
                            <h6 className="ruler">Bus Booking Details</h6>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>FROM    -   TO</th>
                                        <th>Reference No</th>
                                        <th>Booking Status</th>
                                        <th>Ticket PNR</th>
                                        <th>Booking Date</th>
                                        <th>Payment Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>{booking?.sourceName} - {booking?.destinationName}</th>
                                        <td>{booking?.referenceNo}</td>
                                        <td>{booking?.bookingStatus}</td>
                                        <td>{booking?.pnr}</td>
                                        <th> {formatDate(booking?.createdOn)} <span className="color"> {formatTime(booking?.createdOn)}</span></th>
                                        <td>{payments?.paymentStatus}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Travel Info */}
                    <div className="col-md-12">
                        <h6 className="ruler">Bus Details</h6>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Operator</th>
                                        <th>Bus Type</th>
                                        <th>Departure Time</th>
                                        <th>Arrival Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td> {booking?.operatorName}</td>
                                        <td> {booking?.busType}</td>
                                        <th>
                                            {formatDate(booking?.boardingPointTime)} <span className="color">{formatTime(booking?.boardingPointTime)}</span>
                                        </th>

                                        <th>
                                            {formatDate(booking?.droppingPointTime)} <span className="color">{formatTime(booking?.droppingPointTime)}</span>
                                        </th>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* Passenger Info */}

                    <div className="row">

                        {/* Passenger Details */}
                        <div className="col-lg-12">
                            <h6 className="ruler">Passenger Ticket Details</h6>
                            <p>
                                <span style={{ color: booking?.partialCancellationAllowed ? "green" : "red" }}>
                                    {booking?.partialCancellationAllowed
                                        ? "Partial Cancellation Allowed"
                                        : "* Partial Cancellation Not Allowed"}
                                </span>
                            </p>
                        </div>

                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Cancel Ticket</th>
                                            <th>Name</th>
                                            <th>Gender</th>
                                            <th>Age</th>
                                            <th>Seat no</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {passengers.map((p, index) => (
                                            <tr key={p.paxIndex}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {booking?.partialCancellationAllowed ? (
                                                        <input
                                                            type="checkbox"
                                                            className="checkBox"
                                                            checked={selectedSeats.includes(p.seatNo)}
                                                            onChange={() => handlePassengerSelect(p.seatNo)}
                                                        />
                                                    ) : (
                                                        (() => {
                                                            if (selectedSeats.length !== passengers.length) {
                                                                setSelectedSeats(passengers.map(p => p.seatNo));
                                                            }
                                                            return (
                                                                <input
                                                                    type="checkbox"
                                                                    className="checkBox"
                                                                    checked={true}
                                                                    disabled
                                                                />
                                                            );
                                                        })()
                                                    )}
                                                    {/* {booking?.partialCancellationAllowed ? (
                                                        <input
                                                            type="checkbox"
                                                            className="checkBox"
                                                            checked={selectedSeats.includes(p.seatNo)}
                                                            onChange={() => handlePassengerSelect(p.seatNo)}
                                                        />
                                                    ) : (
                                                        index === 0 && (
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedSeats.length === passengers.length}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        setSelectedSeats(passengers.map(p => p.seatNo));
                                                                    } else {
                                                                        setSelectedSeats([]);
                                                                    }
                                                                }}
                                                            />
                                                        )
                                                    )} */}
                                                </td>
                                                <td>{`${p.title} ${p.firstName} ${p.lastName}`}</td>
                                                <td>{p.gender}</td>
                                                <td>{p.age}</td>
                                                <td>{p.seatNo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Submit */}
                        {!hidePreCancellation && (
                            <div className="col-md-12 mt-4 text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={PreCancelledMyBooking}
                                    disabled={loading}
                                >
                                    {loading ? "PrCancelling..." : "Cancel Ticket"}
                                </button>
                            </div>
                        )}
                        {hidePreCancellation && (
                            <div className="col-md-12 mb-3 remrk">
                                <p>Cancellation Charges</p>
                                <div className="col-md-12 mt-4 text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={CancelledMyBooking}
                                        disabled={loading}
                                    >
                                        {loading ? "Cancelling..." : "Cancel Ticket"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};
export default BusCancellationBooking;